export const calculateTotal = (attendanceData, conditionFn) =>
  attendanceData.reduce(
    (total, attendance) => (conditionFn(attendance) ? total + 1 : total),
    0
  );

export const getLeaveStats = (
  attendanceData,
  currentManagerApprovalStatus
) => {
  const today = new Date();

  const nintyDaysAgo = new Date(
    today.getTime() - 180 * 24 * 60 * 60 * 1000
  );

  const totalLeaveRequests = calculateTotal(
    attendanceData,
    (attendance) => {
      const applyDate = new Date(attendance.apply_date);

      return applyDate >= nintyDaysAgo && applyDate <= today;
    }
  );

  const totalLeavesApproved = calculateTotal(
    attendanceData,
    (attendance) => {
      const applyDate = new Date(attendance.apply_date);

      return (
        applyDate >= nintyDaysAgo &&
        applyDate <= today &&
        (
          attendance.is_approved ||
          attendance.is_hr_approved ||
          currentManagerApprovalStatus === "Approved & Forwarded"
        )
      );
    }
  );

  const totalLeavePending = calculateTotal(
    attendanceData,
    (attendance) => {
      const applyDate = new Date(attendance.apply_date);

      return (
        applyDate >= nintyDaysAgo &&
        applyDate <= today &&
        attendance.is_approved === null &&
        attendance.is_hr_approved === null &&
        currentManagerApprovalStatus !== "Approved & Forwarded"
      );
    }
  );

  return {
    totalLeaveRequests,
    totalLeavesApproved,
    totalLeavePending,
  };
};